import * as React from "react";
import { Box, CircularProgress } from "@mui/material";

export default function PageLoadingComponent(props) {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",

        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
